import $ from 'jquery';
import toggleVisibility from 'modules/toggle-visibility';
import revolveMePopup from "modules/revolve-me-popup";
import 'styleguide/modules/slick-carousel';

function toggleFeaturedShopsMenu() {
  $('#js-featured-menu-button').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
    toggleVisibility('featured-shops-list');
  });
}

// When the slide is changing
function playPauseVideo(slick, control) {
  var currentSlide = slick.find(".slick-current");
  var slideType = currentSlide.find('.slick-slideshow__slide').data("media");
  var player = currentSlide.find("iframe").get(0) || currentSlide.find("video").get(0);

  if (slideType != 'video' && slideType != 'youtube') return;

  if (player != null) {
    if (control === "play") {
      player.play();
    } else {
      player.pause();
    }
  }
}

function renderVideoMarkup($slide, videoURL, posterURL) {
  const $anchor = $slide.find('a');
  let $video = $slide.find('video');

  if($video.length === 0) {
    $video = $(`<video autoplay muted loop="loop" playsinline class="u-full-width" poster="${posterURL}">
      <source src="${videoURL}">
    </video>
    `);

    if($anchor.length > 0) {
      $anchor.append($video);
    } else {
      $slide.append($video);
    }
  }

  return $video;
}

function handleVideo($videoSlides) {
  $.each($videoSlides, function(i, slide) {
    var $slide = $(slide);
    var videoURL = $slide.data('video');
    var posterURL = $slide.data('video-poster');
    var videoType;

    if(videoURL.toLowerCase().endsWith(".mp4")) {
      videoType = "video";
    } else {
      videoType = "unknown";
      console.error('There is a video of unknown videoType on the main slideshow.');
    }

    $slide.attr('data-media', videoType);

    const $video = renderVideoMarkup($slide, videoURL, posterURL);
    addMuteButton($slide, $video);
  });
}

function addMuteButton($slide, $video) {
  const video = $video[0];
  const muteButtonClass = 'js-video-mute-btn';
  let $muteButton = $video.find(`.${muteButtonClass}`);
  if($muteButton.length > 0 || $slide.data('video-sound') === false) return;

  $muteButton = $(`
    <button class="${muteButtonClass} u-color--white" style="position:absolute;bottom: 10px;right: 10px;background:transparent; padding: 10px;">
      <span class="js-mute-off icon icon--search icon--sm" style="display:none;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.14 16"><path d="M17.13 7.69c-.03-.73-.14-1.43-.34-2.11-.17-.58-.4-1.13-.68-1.65 0-.01-.01-.02-.02-.04-.03-.06-.07-.12-.1-.18l-.18-.3c-.05-.07-.09-.14-.14-.21a8.468 8.468 0 0 0-3.9-3.12.832.832 0 0 0-.88.12c-.27.21-.4.48-.4.83 0 .17.05.33.14.48.1.14.23.25.4.31 1.27.51 2.29 1.32 3.06 2.43.28.4.51.82.68 1.26.23.58.38 1.19.44 1.83v.07c0 .05 0 .09.01.14v.92c0 .05 0 .09-.01.14v.07c-.06.64-.21 1.25-.44 1.83-.18.44-.41.86-.68 1.26-.24.35-.51.68-.81.97-.45.45-.97.82-1.54 1.13-.23.12-.47.23-.71.33-.17.06-.31.17-.4.31-.02.03-.03.06-.05.09v.02s0 .02-.01.03c-.05.1-.07.21-.07.32 0 .34.15.65.41.84.27.21.56.25.88.12.13-.05.27-.11.39-.17.34-.15.66-.32.96-.51.54-.34 1.04-.73 1.49-1.17.38-.38.73-.8 1.05-1.26.05-.07.09-.14.14-.21l.18-.3c.04-.06.07-.12.1-.18 0-.01.01-.02.02-.04.28-.52.51-1.07.68-1.65.2-.68.31-1.38.34-2.11v-.64Z" /><path d="M12.22 10.26c.17-.29.31-.58.41-.89.07-.21.13-.42.16-.63.04-.23.06-.46.06-.7v-.06c0-.24-.02-.47-.06-.7-.1-.54-.29-1.05-.57-1.52-.42-.7-1-1.22-1.75-1.57v7.65c.75-.35 1.33-.87 1.75-1.57ZM7.99 1.83c-.39-.17-.73-.1-1.04.2L4.76 4.22l-.95.95H.95c-.27 0-.5.09-.68.27S0 5.85 0 6.12v3.81c0 .27.09.5.27.68s.41.27.68.27h2.86l3.14 3.14c.3.3.65.37 1.04.2.39-.16.58-.46.58-.88V2.73c0-.43-.19-.73-.58-.89Z" /></svg></span>
      <span class="js-mute-on icon icon--search icon--sm"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.17 16"><path d="M17.16 7.7c-.03-.73-.14-1.43-.34-2.11-.17-.58-.4-1.13-.68-1.65 0-.01-.01-.02-.02-.04-.03-.06-.07-.12-.1-.18l-.18-.3c-.05-.07-.09-.14-.14-.21A8.528 8.528 0 0 0 11.79.08a.83.83 0 0 0-.88.12c-.27.21-.4.48-.4.83 0 .17.05.33.14.48.1.14.23.25.4.31 1.27.51 2.29 1.32 3.07 2.43.28.4.51.82.68 1.26.23.58.38 1.19.44 1.83v.07c0 .05 0 .09.01.14v.92c0 .05 0 .09-.01.14v.07c-.06.64-.21 1.25-.44 1.83-.06.15-.14.3-.21.45L16 12.37l.03-.06c.04-.06.07-.12.1-.18 0-.01.01-.02.02-.04.28-.52.51-1.07.68-1.65.2-.68.31-1.38.34-2.11v-.64h-.01ZM12.81 8.75c.04-.23.06-.46.06-.7v-.06c0-.24-.02-.47-.06-.7-.1-.54-.29-1.05-.57-1.52-.42-.7-1-1.22-1.75-1.57v2.68l2.23 2.23c.03-.12.07-.24.09-.36ZM8.59 2.73c0-.43-.19-.73-.58-.89-.39-.18-.73-.11-1.04.19l-.66.66 2.28 2.28V2.73ZM1.76.32C1.37-.07.74-.07.35.32s-.39 1.02 0 1.42l3.44 3.44H.95c-.27 0-.5.09-.68.27-.18.18-.27.41-.27.68v3.82c0 .27.09.5.27.68s.41.27.68.27h2.87l3.15 3.15c.3.3.65.37 1.04.2.39-.16.58-.46.58-.88V9.98l5.73 5.73c.2.2.45.29.71.29s.51-.1.71-.29c.39-.39.39-1.03 0-1.42L1.76.32Z" /></svg></span>
    </button>
  `);
  var muteOn = $muteButton.find('.js-mute-on');
  var muteOff = $muteButton.find('.js-mute-off');
  $slide.append($muteButton);

  $muteButton.on('click', () => {
      if (video.muted) {
          video.muted = false;
          muteOn.hide();
          muteOff.show();
      } else {
          video.muted = true;
          muteOn.show();
          muteOff.hide();
      }
  });
}


function setupHomeSlideshow() {
  const language = $('html').attr('lang');
  var rtlBool = language === "ar";
  var $slideshow = $('#js-homepage-slideshow');
  $slideshow.removeClass('slick-slideshow--js-trigger');
  if (language === 'ar') {
    $slideshow.attr('dir', 'rtl');
  }
  var $videoSlides = $slideshow.find('[data-video]');

  handleVideo($videoSlides);


  // Initialize
  $slideshow.on("init", function (slick) {
    slick = $(slick.currentTarget);
    setTimeout(function () {
      playPauseVideo(slick, "play");
    }, 1000);
  });

  $slideshow.on("beforeChange", function (event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick, "pause");
  });

  $slideshow.on("afterChange", function (event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick, "play");
  });


  $slideshow.slick({
    arrows: false,
    dots: true,
    infinite: true,
    mobileFirst: true,
    autoplay: false,
    slidesToShow: 1,
    lazyLoad: 'progressive',
    rtl: rtlBool,
    touchThreshold: 20,
  });
}

function initEditSectionToggle() {
  $('.js-edit-sm').on('click', function () {
    $('.card__entry-section.is-editing').removeClass('is-editing');
    $(this).closest('.card__entry-section').addClass('is-editing').find('.sm-input').focus();
  });
}

$(document).ready(function () {
  setupHomeSlideshow();
  toggleFeaturedShopsMenu();
  revolveMePopup();
  initEditSectionToggle();
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/homepage/index.js